import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HealthService {
  constructor(private http: HttpClient) {}

  healthCheck(): Observable<string> {
    return this.http.get(`${environment.servicesApiUrl}/health`, { responseType: 'text' });
  }

  // TODO resolve CORS issues
  // healthCheckAuth(): Observable<string> {
  //   return this.http.get(`${environment.openIdConnect.issuer}/diagnostics/ping`, {
  //     responseType: 'text',
  //   });
  // }
}
